import { useMemo } from 'react';
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider as QueryClientProviderTanstack,
} from '@tanstack/react-query';
import posthog from 'posthog-js';
import { toast } from 'sonner';

export function QueryClientProvider({ children }: { children: React.ReactNode }) {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: 2,
          },
        },
        queryCache: new QueryCache({
          onSettled: (_data, error, query) => {
            if (error) {
              posthog.captureException(error, {
                kind: 'query',
                queryKey: query.queryKey,
              });
              console.error('query error', error);
            }
          },
        }),
        mutationCache: new MutationCache({
          onError: (error, _variables, _context, mutation) => {
            posthog.captureException(error, {
              kind: 'mutation',
              mutationKey: mutation.options.mutationKey,
            });

            console.error('mutation error', error);

            if (mutation.options.meta?.toastError) {
              toast.error(mutation.options.meta.toastError);
            } else if (mutation.options.meta?.toastError === false) {
              return;
            } else {
              toast.error('Sorry, something went wrong');
            }
          },
        }),
      }),
    []
  );
  return <QueryClientProviderTanstack client={queryClient}>{children}</QueryClientProviderTanstack>;
}
